import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

interface NavigationData {
  currentChargerSelectionTab: 'Map' | 'Search' | 'ScanQr';
}

const initialState: NavigationData = {
  currentChargerSelectionTab: 'Map',
};

// Async thunk for setting the current charger selection tab
export const setCurrentChargerSelectionTabAsync = createAsyncThunk(
  'navigation/setCurrentChargerSelectionTab',
  async (tabSelect: 'Map' | 'Search' | 'ScanQr') => {
    // Simulate a small delay to ensure state update
    await new Promise(resolve => setTimeout(resolve, 10));
    return tabSelect;
  }
);

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setCurrentChargerSelectionTab(state, action) {
      state.currentChargerSelectionTab = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setCurrentChargerSelectionTabAsync.fulfilled, (state, action) => {
      state.currentChargerSelectionTab = action.payload;
    });
  },
});

export const navigationActions = navigationSlice.actions;
export default navigationSlice;
